import React, { useCallback, useState } from 'react';
import classnames from 'classnames';
import readableFileSize from 'filesize';
import FileIcon from '@wix/da-ds/pkg/Icons/24x24/File';
import ScrollableContent from '../../../../../ScrollableContent';
import s from './PremiumAssetList.scss';
var MAX_ASSETS_IN_VISIBLE_SPACE = 2;
export var PremiumAssetList = function (_a) {
    var _b = _a.assets, assets = _b === void 0 ? [] : _b, muted = _a.muted;
    var _c = useState(false), isScrolledToBottom = _c[0], setScrolledToBottom = _c[1];
    var hasOverflow = assets.length > MAX_ASSETS_IN_VISIBLE_SPACE;
    var checkScrollDistance = useCallback(function (scrollTop, distanceToBottom) {
        var isScrolledBottomNew = distanceToBottom < 2;
        if (isScrolledToBottom === isScrolledBottomNew) {
            // let's only update state when something actually changed because things can get laggy
            return;
        }
        setScrolledToBottom(isScrolledBottomNew);
    }, [isScrolledToBottom]);
    return (React.createElement("div", { className: classnames(s['pcp-asset-list'], isScrolledToBottom && s['bottomed']), "aria-disabled": muted },
        React.createElement(ScrollableContent, { wrapperClassName: s['list-wrap'], className: s['scrollable-list'], throttleTimeout: 300, onScrolled: checkScrollDistance },
            React.createElement("ul", { className: s['pcp-assets'] }, assets.map(function (_a) {
                var filename = _a.filename, filesize = _a.filesize, width = _a.width, height = _a.height;
                return (React.createElement("li", { key: filename, className: s['asset'] },
                    React.createElement("div", { className: classnames(s['asset-icon'], muted && s['muted']) },
                        React.createElement(FileIcon, null)),
                    React.createElement("div", { className: classnames(s['asset-info'], muted && s['muted']) },
                        React.createElement("div", { className: s['asset-info-top'] },
                            React.createElement("div", { className: s['asset-filename'] }, filename),
                            width && height && (React.createElement("div", { className: s['asset-resolution'] },
                                width,
                                "x",
                                height,
                                "px"))),
                        filesize && (React.createElement("div", { className: s['asset-filesize'] }, readableFileSize(filesize))))));
            })),
            hasOverflow && React.createElement("div", { className: s['fade'] }))));
};
PremiumAssetList.displayName = 'PremiumAssetList';
export default PremiumAssetList;
//# sourceMappingURL=PremiumAssetList.js.map